import React from 'react';
// TODO: Не стал разделять на отдельные версии для десктопа и мобайла, так как токены одинаковые везде
// Плюс это вообще неправильное по дизайну решение для тултипа
// В тултип сами дизайнеры говорили, что помещаем не больше 12 строчек, а тут целая простыня получается
// Дизайнеры в курсе про этот момент, когда решать будут, пока не ясно
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

export const HintBondPrice = () => (
    <>
        <Text styler={{ marginTop: 0 }} view="primary-small">
            Рыночная цена облигации выражается в процентах от номинала. Например, номинал 1000 ₽ —
            это 100%. Если рыночная цена облигации 101,5%, то в рублях это 1015 ₽. А если 99,6%, то
            в рублях это будет 996 ₽. Цена отображается в процентах, чтобы быстро оценивать
            доходности бумаги вне зависимости от номинала.
        </Text>
        <Text view="primary-small">
            Данные могут обновляться с задержкой. Посмотреть актуальную цену можно в веб-терминале
            или приложении Альфа-Инвестиции.
        </Text>
    </>
);
